(function () {
  function addArrow(labelEl, isOpen) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 10 6');
    svg.classList.add('icon', 'icon-caret');
    svg.style.width = '10px';
    svg.style.height = '6px';
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('fill', 'currentColor');
    path.setAttribute('fill-rule', 'evenodd');
    path.setAttribute('d', 'M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708');
    path.setAttribute('clip-rule', 'evenodd');
    svg.appendChild(path);
    labelEl.appendChild(svg);
    if (isOpen) labelEl.classList.add('cl-open');
  }

  function collapse(optionEl) {
    optionEl.classList.add('cl-collapsed');
    optionEl.querySelector('.cl-po--label').classList.remove('cl-open');
  }

  function expand(optionEl) {
    optionEl.classList.remove('cl-collapsed');
    optionEl.querySelector('.cl-po--label').classList.add('cl-open');
  }

  function unlock(optionEl) {
    optionEl.classList.remove('cl-locked');
    expand(optionEl);
  }

  function init() {
    const options = Array.from(document.querySelectorAll('.cl-po--option'));
    if (!options.length) return;

    options.forEach(function (opt, i) {
      const label = opt.querySelector('.cl-po--label');
      if (!label) return;

      addArrow(label, i === 0);
      if (i !== 0) {
        opt.classList.add('cl-locked', 'cl-collapsed');
      }

      label.addEventListener('click', function () {
        if (opt.classList.contains('cl-locked')) return;
        opt.classList.contains('cl-collapsed') ? expand(opt) : collapse(opt);
      });
    });

    function unlockNext(i) {
      const next = options[i + 1];
      if (next && next.classList.contains('cl-locked')) unlock(next);
    }

    options[0] && options[0].querySelectorAll('input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', function () { unlockNext(0); });
    });

    options[1] && options[1].querySelectorAll('input[type="text"]').forEach(function (input) {
      input.addEventListener('input', function () {
        const all = Array.from(options[1].querySelectorAll('input[type="text"]'));
        if (all.every(function (i) { return i.value.trim() !== ''; })) unlockNext(1);
      });
    });

    options[2] && options[2].querySelectorAll('input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', function () { unlockNext(2); });
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();